import api from './api';

export const toList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

// Kullanıcı Servisleri
export const userService = {
  register: (data) => api.post('/users/register/', data),
  login: (username, password) => api.post('/users/login/', { username, password }),
  sessionHeartbeat: (data) => api.post('/users/session-heartbeat/', data),
  getProfile: () => api.get('/users/profile/'),
  updateProfile: (data) => api.put('/users/profile/', data),
  getUser: (id) => api.get(`/users/profile/${id}/`),
  changePassword: (data) => api.post('/users/profile/change_password/', data),
  deleteAccount: () => api.post('/users/profile/delete_account/'),
};

export const adminUserService = {
  getUsers: (params) => api.get('/users/admin/users/', { params }),
  updateUser: (id, data) => api.patch(`/users/admin/users/${id}/`, data),
  getUserDetail: (id) => api.get(`/users/admin/users/${id}/detail/`),
  assignCourse: (id, courseId) => api.post(`/users/admin/users/${id}/assign-course/`, { course_id: courseId }),
  getQuickApplications: (params) => api.get('/users/admin/quick-applications/', { params }),
  getContactMessages: (params) => api.get('/users/admin/contact-messages/', { params }),
  updateContactMessage: (id, data) => api.patch(`/users/admin/contact-messages/${id}/`, data),
};

export const leadService = {
  submitQuickApplication: (data) => api.post('/users/quick-applications/', data, { skipAuth: true }),
  submitContactMessage: (data) => api.post('/users/contact/', data, { skipAuth: true }),
};

export const blogService = {
  getPosts: (params) => api.get('/blog/', { params, skipAuth: true }),
  getPostDetail: (slug) => api.get(`/blog/${slug}/`, { skipAuth: true }),
};

export const adminBlogService = {
  getPosts: (params) => api.get('/blog/admin/posts/', { params }),
  createPost: (formData) => api.post('/blog/admin/posts/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updatePost: (id, formData) => api.put(`/blog/admin/posts/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deletePost: (id) => api.delete(`/blog/admin/posts/${id}/`),
};

export const trainingService = {
  getItems: (params) => api.get('/trainings/', { params, skipAuth: true }),
};

export const adminTrainingService = {
  getItems: (params) => api.get('/trainings/admin/items/', { params }),
  createItem: (formData) => api.post('/trainings/admin/items/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updateItem: (id, formData) => api.put(`/trainings/admin/items/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteItem: (id) => api.delete(`/trainings/admin/items/${id}/`),
};

// Kurs Servisleri
export const courseService = {
  getCourses: (params) => api.get('/courses/', { params }),
  getCourseDetail: (slug) => api.get(`/courses/${slug}/`),
  getLearningCourseDetail: (slug) => api.get(`/courses/learning/${slug}/`),
  getCategories: () => api.get('/courses/categories/'),
  submitReview: (slug, data) => api.post(`/courses/${slug}/reviews/`, data),
  getCourseProgress: (slug) => api.get(`/courses/progress/${slug}/`),
  updateLessonProgress: (data) => api.post('/courses/progress/', data),
  getLiveSessions: (slug) => api.get(`/courses/live/${slug}/`),
  issueCertificate: (slug) => api.post(`/courses/certificates/issue/${slug}/`),
  getMyCertificates: () => api.get('/courses/certificates/my/'),
  verifyCertificate: (certificateCode) => api.get(`/courses/certificates/verify/${certificateCode}/`),
};

export const adminCourseService = {
  getCategories: () => api.get('/courses/admin/categories/'),
  createCategory: (data) => api.post('/courses/admin/categories/', data, {
    headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
  }),
  updateCategory: (id, data) => api.put(`/courses/admin/categories/${id}/`, data, {
    headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : undefined,
  }),
  deleteCategory: (id) => api.delete(`/courses/admin/categories/${id}/`),
  getCourses: () => api.get('/courses/admin/courses/'),
  createCourse: (formData) => api.post('/courses/admin/courses/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updateCourse: (id, formData) => api.put(`/courses/admin/courses/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteCourse: (id) => api.delete(`/courses/admin/courses/${id}/`),
  createSection: (data) => api.post('/courses/admin/sections/', data),
  updateSection: (id, data) => api.put(`/courses/admin/sections/${id}/`, data),
  deleteSection: (id) => api.delete(`/courses/admin/sections/${id}/`),
  createLesson: (formData) => api.post('/courses/admin/lessons/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updateLesson: (id, formData) => api.put(`/courses/admin/lessons/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteLesson: (id) => api.delete(`/courses/admin/lessons/${id}/`),
  getLiveSessions: () => api.get('/courses/admin/live-sessions/'),
  createLiveSession: (data) => api.post('/courses/admin/live-sessions/', data),
  updateLiveSession: (id, data) => api.put(`/courses/admin/live-sessions/${id}/`, data),
  deleteLiveSession: (id) => api.delete(`/courses/admin/live-sessions/${id}/`),
  getCertificateTemplates: () => api.get('/courses/admin/certificate-templates/'),
  upsertCertificateTemplate: (formData) => api.post('/courses/admin/certificate-templates/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  updateCertificateTemplate: (id, formData) => api.put(`/courses/admin/certificate-templates/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteCertificateTemplate: (id) => api.delete(`/courses/admin/certificate-templates/${id}/`),
};

// Sepet Servisleri
export const cartService = {
  getCart: () => api.get('/orders/cart/'),
  addToCart: (courseId, selection = {}) => api.post('/orders/cart/add/', { course_id: courseId, ...selection }),
  removeFromCart: (itemId) => api.delete(`/orders/cart/remove/${itemId}/`),
  validateCoupon: (data) => api.post('/orders/validate-coupon/', data),
};

// Sipariş Servisleri
export const orderService = {
  createOrder: (data) => api.post('/orders/checkout/', data),
  getOrders: () => api.get('/orders/orders/'),
  getOrder: (id) => api.get(`/orders/orders/${id}/`),
  getPurchases: () => api.get('/orders/purchases/'),
  getAdminDashboard: () => api.get('/orders/admin/dashboard/'),
};

// Ödeme Servisleri
export const paymentService = {
  createStripeCheckout: (orderId) => api.post('/payments/stripe/checkout/', { order_id: orderId }),
  createPayTRCheckout: (orderId) => api.post('/payments/paytr/checkout/', { order_id: orderId }),
  getPaymentStatus: (transactionId) => api.get(`/payments/status/${transactionId}/`),
  getPaymentHistory: () => api.get('/payments/history/'),
  getInvoices: () => api.get('/payments/invoices/'),
  requestRefund: (data) => api.post('/payments/refund/', data),
};
